import { SxProps, Theme } from '@mui/material';

import {
  FlexColumn,
  OverflowAwareText,
} from '~components/Order/ordersDispatchStyledComponents';
import { Load } from '~hooks/useLoad/models';

interface PhaseColumnProps {
  load: Load;
  sx?: SxProps<Theme>;
}

export default function PhaseColumn({ load, sx }: PhaseColumnProps) {
  const phase = load.phase;

  return (
    <FlexColumn sx={sx}>
      <OverflowAwareText>{phase?.name ?? '-'}</OverflowAwareText>

      <OverflowAwareText sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}>
        {phase?.code ?? '-'}
      </OverflowAwareText>
    </FlexColumn>
  );
}
